import React from 'react';

export default function BrowserDesktopRequiredScreen() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0a0a14', fontFamily: "'Inter', -apple-system, sans-serif", padding: 20,
    }}
    >
      <div style={{ textAlign: 'center', maxWidth: 440 }}>
        <div style={{
          fontSize: 20, fontWeight: 800, letterSpacing: '0.18em', textTransform: 'uppercase',
          background: 'linear-gradient(135deg, rgba(255,255,255,0.85), #C9A84C 60%, #E8D48B)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
          marginBottom: 32,
        }}
        >
          Maestro
        </div>
        <h1 style={{ color: '#fff', fontSize: 22, fontWeight: 700, margin: '0 0 12px' }}>
          Desktop App Required
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, lineHeight: 1.6, margin: '0 0 28px' }}>
          Maestro is designed to run as a native application, not in a web browser.
          Please download and install the Maestro app for the best experience.
        </p>
        <a
          href="/download"
          style={{
            display: 'inline-block', padding: '14px 32px', background: '#C9A84C',
            color: '#1a1a2e', borderRadius: 12, fontSize: 15, fontWeight: 700,
            textDecoration: 'none',
          }}
        >
          Download Maestro
        </a>
      </div>
    </div>
  );
}
